import React from 'react';

import productIntegration from '../../../main/assets/images/rapidFire/rapid-fire-in-goggles.webp';
import productIntegrationMobile from '../../../main/assets/images/rapidFire/rapid-fire-in-goggles-mobile.webp';

export const OrqaIntegration = () => {
  return (
    <section className="rapid-fire-integration-section">
      <div className="rapid-fire-integration-text">
        <h2 className="rapid-fire-intergration-title">
          <span className="first-line">Superb Orqa</span>
          <span className="second-line">Integration</span>
        </h2>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="2"
          viewBox="0 0 100 2"
          preserveAspectRatio="none"
          className="rapid-fire-integration-line"
        >
          <path d="M0 0.5H656" stroke="url(#paint0_linear_1053_2725)" />
          <defs>
            <linearGradient
              id="paint0_linear_1053_2725"
              x1="0"
              y1="1"
              x2="100"
              y2="1"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.509" stopColor="#FF2238" />
              <stop offset="1" stopColor="#FF2238" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <div className="rapid-fire-intergration-description-logo">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 126 125"
            width={126}
            height={125}
            fill="none"
            className="rapid-fire-integration-logo"
            preserveAspectRatio="xMidYMid meet"
          >
            <circle
              cx="63"
              cy="62.5"
              r="50"
              fill="#FF2238"
              filter="url(#filter0_d_1053_2727)"
            />
            <g transform="translate(63,62.5) scale(1.5) translate(-63,-62.5)">
              <path
                d="M63.199 69.1814V42.4839L86.2935 69.1814L83.0302 75.6039H69.6002L63.199 69.1814Z"
                fill="black"
              />
              <path
                d="M59.8102 69.1814V54.1955L54.7896 55.7067L39.8535 72.4556L42.9914 75.6039H53.409L59.8102 69.1814Z"
                fill="black"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_1053_2727"
                x="0.700001"
                y="0.200001"
                width="124.6"
                height="124.6"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="6"
                  operator="dilate"
                  in="SourceAlpha"
                  result="effect1_dropShadow_1053_2727"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="10.15" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.374167 0 0 0 0 0.436467 0 0 0 0.4 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_1053_2727"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_1053_2727"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
          <p className="rapid-fire-intergration-description">
            The rapidFIRE integrates perfectly with Orqa FPV.One, FPV.One Pilot,
            and FPV.One Race systems, allowing direct module control through
            Orqa headsets for a fully streamlined FPV experience.
          </p>
        </div>
      </div>
      <img
        src={productIntegration}
        alt="Goggles FPV Module Integration"
        className="rapid-fire-integration-product"
      />

      <img
        src={productIntegrationMobile}
        alt="Goggles FPV Module Integration"
        className="rapid-fire-integration-product rapid-fire-integration-product-mobile"
      />
    </section>
  );
};
